<template>
  <div id="active-plans">
    <PageTitle title="Farms" backLink="/farms" class="p" />
    <b-container>
      <b-row class="mt-4" v-if="loadingData && !loadError">
        <b-col
          v-for="(item, index) in 3"
          cols="12"
          md="6"
          lg="4"
          :key="item + index"
          class="mb-4"
        >
          <b-progress
            variant="primary"
            :max="100"
            class="w-100"
            show-progress
            animated
            height="200px"
          >
            <b-progress-bar :value="100">Loading...</b-progress-bar>
          </b-progress>
        </b-col>
      </b-row>
      <b-row v-else-if="loadError" class="mt-4" align-v="stretch">
        <b-col cols="12" class="mb-4">
          <div class="text-center" title="Could not load, click on retry">
            <b-button
              size="sm"
              @click="loadInvestments()"
              variant="light"
              class="w-100"
              style="height:200px"
            >
              <bad-network-icon />
              <br />Error Loading Data, <br />click to retry
              <reload-icon class="ml-1" />
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="subscriptions.length > 0 && !loadingData && !loadError">
        <b-col cols="12">
          <div class="wrap dash-card bg-white position-relative card-shadow">
            <div class="wrap p-0 mt-2">
              <div
                class="dash-card bg-dark shadow-xl text-white"
                style=" padding:30px 20px; margin-bottom:10px"
                :style="{
                  backgroundImage:
                    ` linear-gradient(0deg, rgba(0,0,0,0.6), transparent), url(` +
                    farm_img +
                    `)`,
                }"
              >
                <b-row no-gutters>
                  <b-col cols="12" class="px-3">
                    <h4 class="mb-0 mr-2">
                      {{ subscriptions[0].location.locationname }} Farm
                    </h4>
                    <p class="d-inline-block mb-0 mr-2">
                      Total: {{ subscriptions[0].units }} unit{{subscriptions[0].units === 1 ? '':'s'}} of farm land
                    </p>
                    <hr class="mt-0" />
                        <p class="mb-0 mr-2">
                          <b>{{ Math.round(calcFarmUsage) }} unit(s) farmland in use</b>
                        </p>
                        <p class=" mb-0 mr-2">
                          <b>{{ Math.round(calcFarmSpace) }} available unit(s) farmland</b>
                        </p>

                    <div class="d-flex">
                      <b-col md="6" align-h="between" class="p-0 mt-3">
                        <b-row class="no-gutters">
                          <!-- <b-col md="6" sm="12" class="mb-3">
                            <b-button
                              variant="light"
                              @click="handleDetails()"
                              class="w-100 "
                              >Details</b-button
                            >
                          </b-col> -->
                        </b-row>
                      </b-col>
                    </div>
                  </b-col>
                  <br />
                </b-row>

                <b-row v-if="subscriptions[0].units > subscriptions[0].plantedslots">
                  <b-col md="12" sm="12">
                    <b-button
                      variant="primary"
                      @click="handleInvest()"
                      class="float-right"
                      >Farm For Me</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row
        v-if="subscriptions.length > 0"
        class="mt-4"
        align
        align-v="stretch"
      >
        <b-col
          class="mb-5 mr-20"
          cols="12"
          md="6"
          lg="6"
          xl="4"
          v-for="(farm, index) in subscriptions[0].farmmanagements"
          :key="farm + index"
        >
          <b-button
            @click="handleClicked(farm)"
            variant="white"
            class="w-100 wrapper h-100 bg-white dash-card investment-blocks text-left p-0"
          >
            <div
              class="upper mb-1 bg-light p-4 text-white shadow-2xl"
              :style="{
                backgroundImage:
                  ` linear-gradient(0deg, rgba(0,0,0,0.6), transparent), url(` +
                  farm.farmservice.imageurl +
                  `)`,
              }"
            >
              <b-row align-h="between">
                <b-col cols="auto">
                  <h5>
                    {{ farm.farmservice.farmingname }} <br />
                    <div style="font-size:15px">
                      {{
                        parseFloat(farm.farmservice.maxroi) +
                          "% in " +
                          farm.farmservice.farmingcycle +
                          " months"
                      }}
                    </div>
                  </h5>
                </b-col>
                <b-col cols="auto" class="text-right">
                  <i
                    v-if="farm.farmservice.status == 'active'"
                    class="fa fa-check-circle fa-lg text-primary"
                    aria-hidden="true"
                  ></i>
                  <!-- <component
                    class="text-white"
                    :is="`${plannedSubscription.type}-icon`"
                    :size="40"
                  ></component> -->
                </b-col>
              </b-row>
            </div>
            <div class="upper p-4">
              <h4 class="mb-0 lft">
                <Money class="text-primary mb-0" :value="farm.amount || 0" />
              </h4>
              <small class="text-dark rgt" style="margin-top: 5px"
                >{{ farm.farmunits }} Unit(s)</small
              >
              <div class="clr"></div>
              <b-row style="margin-top: 10px">
                <b-col class="wrap">
                  <small>Growth:</small>
                  <span class="d-block text-orange">{{
                    formatMoney(farm.roitoday)
                  }}</span>
                </b-col>
                <b-col class="wrap" align="right">
                  <small>Returns:</small>
                  <span class="d-block text-orange">{{
                    formatMoney(farm.estimatedreturns)
                  }}</span>
                </b-col>
              </b-row>
              <b-progress
                class="mb-3 progress-bar-striped"
                :value="farm.dayssofar"
                :max="farm.investmentdays"
                height="7px"
              ></b-progress>

              <b-row align-h="between">
                <b-col>
                  <small class="d-block text-black-50">Acquired:</small>
                  <small class="d-investment text-dark">
                    {{
                      LuxonDateTime.fromJSDate(
                        new Date(farm.farmservice.createdat)
                      ).toFormat("LLL dd yyyy")
                    }}
                  </small>
                </b-col>
                <b-col class="text-right">
                  <small class="d-block text-black-50">Matures:</small>
                  <small class="d-investment text-dark">
                    {{
                      LuxonDateTime.fromJSDate(new Date(farm.enddate)).toFormat(
                        "LLL dd yyyy"
                      )
                    }}
                  </small>
                </b-col>
              </b-row>
            </div>
          </b-button>
        </b-col>
      </b-row>

      <div></div>
      <b-row
        v-if="
          subscriptions[0].farmmanagements.length == 0 &&
            !loadingData &&
            !loadError
        "
      >
        <b-col cols="12">
          <div
            class="d-flex bg-white dash-card p-5 align-items-center justify-content-center"
            style="height:200px"
          >
            <div class="wrap text-center">
              <h5>Your farm has no crop planted on it</h5>
              <b-button variant="primary" @click="handleInvest"
                >Farm for me</b-button
              >
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- <FarmPackagePayment v-if="activeRequest.id!=undefined" :request="activeRequest" /> -->
    </b-container>
  </div>
</template>

<script>
import { DateTime as LuxonDateTime } from "luxon";
import { UserService } from "@/services";
import { formatMoney } from "@/utils/helpers";
import loadData from "@/mixins/loadData";
import FarmForMeSidebar from "./FarmForMeSidebar";
import FarmDetails from "./FarmDetails";
import PageTitle from "../../../components/ui/PageTitle";
// import FarmPackagePayment from "./FarmPackagePayment";

export default {
  data() {
    return {
      value: "70",
      display: false,
      subscriptions: [
        {
          farmmanagements: [],
          location: {
            locationname: "",
          },
        },
      ],
      activeRequest: {},
      requests: {},
      LuxonDateTime: LuxonDateTime,
      farm_img: "https://agbeloba-media.s3.amazonaws.com/cassava.jpg",
    };
  },
  mixins: [loadData],

  computed: {
    calcFarmUsage() {
      return (
        (this.subscriptions[0].percentageplanted / 100) *
        this.subscriptions[0].units
      );
    },

    calcFarmSpace() {
      let sub = this.subscriptions[0];
      return sub.units - (sub.percentageplanted / 100) * sub.units;
    },
  },

  methods: {
    formatMoney,
    async loadInvestments() {
      this.loadingData = true;
      this.loadError = false;
      try {
        let id = this.$route.params.id;

        const { data } = await UserService.getFarmSingleSubscriptions(id);
        let subscriptions = data.data.subscriptions;

        // subscriptions = [
        //   {
        //     location: { locationname: "Atan", amount: 200000 },
        //     units: "36",
        //     farmmanagements: [],
        //     package: { plotsize: "2", type: "sale" },
        //   },
        // ];

        //  data.data.subscriptions;

        if (subscriptions.length == 0) {
          this.loadFarmRequests();
        }

        this.subscriptions = [];

        subscriptions.forEach((sub) => {
          // if (sub.package.type == "sale") {
          this.subscriptions.push(sub);
          // }
        });
      } catch (err) {
        this.loadError = true;
      } finally {
        this.loadingData = false;
      }
    },
    async loadFarmRequests() {
      this.loadingData = true;
      this.loadError = false;
      try {
        const { data } = await UserService.getFarmRequests();

        let requests = data.requests;

        this.requests = [];

        requests.forEach((request) => {
          if (request.package.type == "sale") {
            this.requests.push(request);
          }
        });
      } catch (err) {
        this.loadError = true;
      } finally {
        this.loadingData = false;
      }
    },
    handleInvest() {
      const panelResult = this.$showPanel({
        component: FarmForMeSidebar,
        openOn: "right",
        width: "495px",
        disableBgClick: true,
        props: {
          subscription: this.subscriptions[0],
        },
      });

      panelResult.promise.then((result) => {
        if (result.closedBy != "bg") {
          this.$emit("setActiveTab");
        }
        this.loadFarmRequests();
        //result is the value passed from your component calling this.$emit('close-panel', //some value);
      });
    },
    handleDetails() {
      const panelResult = this.$showPanel({
        component: FarmDetails,
        openOn: "right",
        width: "400px",
        props: {
          subscription: this.subscriptions[0],
        },
      });

      panelResult.promise.then((result) => {
        if (result.closedBy != "bg") {
          this.$emit("setActiveTab");
        }

        //result is the value passed from your component calling this.$emit('close-panel', //some value);
      });
    },

    handleClicked(subscription) {
      this.activeRequest = subscription.request;
      this.activeRequest.package = subscription.package;
      this.activeRequest.location = subscription.location;
      this.activeRequest.subscription = subscription;

      this.$bvModal.show("request-modal");
    },
  },
  components: {
    PageTitle,
    // 'FarmForMeSidebar':FarmForMeSidebar
  },
  mounted() {
    this.loadInvestments();
    // alert(this.$route.params.activefarm);
  },
};
</script>

<style>
.upper {
  background-size: cover;
  border-radius: 5px 5px 0 0;
}

.wrap small {
  font-size: 12px;
  font-weight: 700;
}

.wrap .d-block {
  font-size: 15px;
  font-weight: 700;
}

h6 {
  text-transform: capitalize;
}
.Farmplan-btn {
  color: #fff;
}

.card-shadow {
  /* border-radius: 30px; */
  box-shadow: -2px 10px 40px rgb(207, 207, 207);
}

.card-shadow i {
  font-size: 30px;
  padding: 10px;
}

.location-price {
  font-size: 20px;
  color: rgb(1, 148, 14);
}

.location-unit {
  font-size: 13px;
  float: right;
  margin-top: 4px;
}
.font-small {
  font-size: 14px;
  /* color: rgb(207, 13, 13) */
}

.plan-cards img {
  /* width: 400px; */
  height: 220px;
  /* background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), transparent), */
}
</style>
